export const typography = {
  fontFamily: {
    code: ['Menlo', 'ui-monospace', 'SFMono-Regular', 'Monaco', 'monospace'],
  },
  fontWeight: {
    custom: '600',
  },
  letterSpacing: {
    'really-tight': '-0.001rem',
  },
  lineHeight: {
    looser: '4',
  },
};
